<template>
  <div class="mt-2 text-center">
    <h4 class="pb-2">
      {{ this.$t('SmartMatch.isThisRight') }}
    </h4>
    <h5 class="pb-2">
      {{ description }}
    </h5>
    <div class="align-center pb-2">
      <button class="btn btn-aisler-gradient me-2" @click="$emit('confirm')">
        {{ this.$t('SmartMatch.yes') }}
      </button>
      <button class="btn btn-secondary" @click="$emit('decline')">
        {{ this.$t('SmartMatch.no') }}
      </button>
    </div>
    <p class="pt-2" v-html="this.$t('SmartMatch.parameterRefinement')" />
  </div>
</template>

<script>
import messages from 'locales/SmartMatch';

export default {
  name: 'SmartMatch',
  props: {
    description: String,
  },
  emits: ['confirm', 'decline'],
  i18n: { messages },
};
</script>

<style lang="scss" scoped>
</style>
